define('modules/accounts/companies/detail/form-company-services-view',['require','exports','module','views/BaseView','ldsh!./form-company-services-template'],function(require, exports, module) {
    "use strict";

    var BaseView = require("views/BaseView");

    var View = BaseView.extend({
        template: require("ldsh!./form-company-services-template"),
        initialize: function() {},
        serialize: function() {
            return {
                service: this.model,
                group: this.group
            };
        }
    });

    module.exports = View;
});

